<template>
  <div id="certificate" class="certificate">
    <div class="top-img" v-if="this.$route.path === '/certificate'">
      <img style="width: 100%;" alt="YwgA84rAI"
           src="@/assets/images/k2hqdmpfendk2hqdmpfend.jpg">
    </div>
    <div class="certificate-row container" data-aos="fade-right" data-aos-duration="500">
      <MyTitle>
        <template v-slot:title><b style="color:#1E55AE;">专利</b>证书</template>
      </MyTitle>
      <el-collapse
          accordion
          v-model="activeNames"
          v-loading="loading1"
          element-loading-text="拼命加载中...">
        <el-empty :image-size="200" v-if="categorizeList.length === 0"></el-empty>
        <el-collapse-item
            :id="categorize.anchorId"
            :title="categorize.title"
            :name="categorize.anchorId"
            v-for="categorize in categorizeList"
            :key="categorize.id"
            @click.native="handleChange(categorize.id)"
        >
          <ul class="certificate-list">
            <li v-for="certificate in certificateObj[categorize.id]" :key="certificate.id"
                data-aos="zoom-in" data-aos-duration="1500">
              <el-image :src="certificate.image_url"
                        :preview-src-list="certificateObj[categorize.id].map(item=>item.image_url)"
                        lazy>
                <div slot="placeholder" class="image-slot">
                  <img src="@/assets/images/loading.gif" alt="loading" style="width: 100px;">
                </div>
              </el-image>
              <p>{{ certificate.title }}</p>
            </li>
            <el-empty :image-size="200"
                      v-if="certificateObj[categorize.id] && certificateObj[categorize.id].length === 0"></el-empty>
          </ul>
        </el-collapse-item>
        <el-collapse-item title="行业标准">
          <ul class="certificate-list">
            <li data-aos="zoom-in" data-aos-duration="1500"
                v-for="item in standards" :key="item.id"
                style="cursor: pointer;">
              <a :href="item.file_url" target="_blank">
                <el-image :src="item.img_url" lazy>
                  <div slot="placeholder" class="image-slot">
                    <img src="@/assets/images/loading.gif" alt="loading" style="width: 100px;">
                  </div>
                </el-image>
                <p>{{ item.name }}</p>
              </a>
            </li>
          </ul>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
export default {
  name: "Certificate",
  data() {
    return {
      activeIdx: "",
      activeNames: [],
      certificateList: [],
      certificateObj: {},
      categorizeList: [],
      loading1: false,
      standards: [
        {
          id: 1,
          name: "NBT 10813-2021 接力器外置型转桨式水轮机桨叶调节装置基本技术条件",
          img_url: "http://www.energyst.cn/folder/media/article/images/%E6%8E%A5%E5%8A%9B%E5%99%A8%E5%A4%96%E7%BD%AE%E5%9E%8B%E8%BD%AC%E6%A1%A8%E5%BC%8F%E6%B0%B4%E8%BD%AE%E6%9C%BA%E6%A1%A8%E5%8F%B6%E8%B0%83%E8%8A%82%E8%A3%85%E7%BD%AE%E5%9F%BA%E6%9C%AC%E6%8A%80%E6%9C%AF%E6%9D%A1%E4%BB%B6_20231222172816_149.jpg",
          file_url: "http://www.energyst.cn/folder/media/article/files/NBT%2010813-2021%20%E6%8E%A5%E5%8A%9B%E5%99%A8%E5%A4%96%E7%BD%AE%E5%9E%8B%E8%BD%AC%E6%A1%A8%E5%BC%8F%E6%B0%B4%E8%BD%AE%E6%9C%BA%E6%A1%A8%E5%8F%B6%E8%B0%83%E8%8A%82%E8%A3%85%E7%BD%AE%E5%9F%BA%E6%9C%AC%E6%8A%80%E6%9C%AF%E6%9D%A1%E4%BB%B6_20231222173153_902.pdf"
        },
        {
          id: 2,
          name: "NBT10475-2020高油压受油器技术条件",
          img_url: "http://www.energyst.cn/folder/media/article/images/%E9%AB%98%E6%B2%B9%E5%8E%8B%E5%8F%97%E6%B2%B9%E5%99%A8%E6%8A%80%E6%9C%AF%E6%9D%A1%E4%BB%B6_20231222172816_845.jpg",
          file_url: "http://www.energyst.cn/folder/media/article/files/NBT10475-2020%E9%AB%98%E6%B2%B9%E5%8E%8B%E5%8F%97%E6%B2%B9%E5%99%A8%E6%8A%80%E6%9C%AF%E6%9D%A1%E4%BB%B6%EF%BC%88%E6%95%B4%E6%9C%AC)_20231222173153_976.pdf"
        },
      ]
    };
  },

  methods: {
    setActivePatent(anchorItem) {
      this.activeNames = [anchorItem.anchorId]
      this.handleChange(anchorItem.id)
    },

    handleChange(categorizeId) {
      if (!this.certificateObj[categorizeId]) {
        this.activeIdx = categorizeId
        this.getCertificateList()
      }
    },

    // 实现描点跳转
    goAnchorModel(anchorItem) {
      const anchorId = anchorItem.anchorId
      if (this.$route.path === '/certificate') {
        if (anchorId) {
          this.setActivePatent(anchorItem)
          setTimeout(() => {
            this.$bus.$emit("goAnchor", anchorId)
          }, 300)
        }
      }
    },

    // 请求证书数据
    async getCertificateList() {
      try {
        this.loading1 = true

        if (this.categorizeList.length === 0) {
          await this.getCertificateCategorizeList()
          this.$route.params.anchorItem && this.goAnchorModel(this.$route.params.anchorItem)
        }

        let results = await this.$api.reqCertificateList({categorize: this.activeIdx})

        if (results.status === 200) {
          this.certificateObj[this.activeIdx] = results.results
        }
      } catch (e) {
        this.$message({showClose: true, message: '证书列表请求失败！', type: 'error'})
      } finally {
        this.loading1 = false
      }
    },

    // 请求证书类型
    async getCertificateCategorizeList() {
      let results = await this.$api.reqCertificateCategorizeList()
      if (results.status === 200) {
        this.categorizeList = results.results

        const anchorItem = this.$route.params.anchorItem

        this.activeNames = results.results[0].anchorId
        this.activeIdx = results.results[0].id

        if (anchorItem && anchorItem.anchorId) {
          this.activeNames = anchorItem.anchorId
          this.activeIdx = anchorItem.id
        }

        return 'ok'
      } else {
        this.$message({showClose: true, message: '类型列表请求失败！', type: 'error'})
        return Promise.reject(new Error('error'));
      }
    },
  },

  mounted() {
    this.getCertificateList()
    this.$bus.$on("goAnchorModel", this.goAnchorModel)
    this.$bus.$on("setActivePatent", this.setActivePatent)
  },
  beforeDestroy() {
    this.$bus.$off("goAnchorModel");
    this.$bus.$off("setActivePatent");
  }
}
</script>

<style scoped lang="less">
.certificate {

  .certificate-row {
    padding: 80px 0 115px 0;
    margin: 0 auto;
    text-align: center;

    .certificate-list {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: row;
      flex-wrap: wrap;

      li {
        display: flex;
        align-items: center;
        flex-direction: row;
        flex-wrap: wrap;
        margin: 10px 20px;
        width: 190px;

        .el-image {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 278px;
          width: 190px;
          box-shadow: 0 0 3px #666;
        }

        /deep/ .el-image__inner {
          height: auto;
        }

        p {
          padding-top: 10px;
          width: 190px;
          height: 70px;
          font-size: 14px;
          color: #666666;
        }
      }
    }

    /deep/ .el-collapse {
      margin-top: 50px;

      .el-collapse-item__header {
        padding: 0 20px;
        height: 55px;
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.12);
        font-size: 16px;
        font-weight: normal;
      }

      .el-collapse-item__content {
        padding: 25px 0;
        min-height: 365px;
      }

      .is-active {
        color: white;
        background-color: #1E55AE;
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.12);
      }
    }

    /deep/ .el-image__preview {
      cursor: url('~@/assets/images/magnifier.png'), default;
    }
  }
}
</style>
